<button isStarter class="beamerButton text-gray-800 flex gap-2 items-center justify-center">
    <mat-icon
        svgIcon="heroicons_outline:newspaper"
        class="text-blue-700"
        [ngClass]="{ 'icon-size-5': iconSize === 'sm', 'icon-size-8': iconSize === 'md' }"
    ></mat-icon>
    <div *ngIf="hasText" class="text-lg">Atualizações da plataforma</div>
</button>
